import React from "react";
import StandardButton from "../UI/buttons/StandardButton";
import labels from "../../utils/labels";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { triggerRefetch, setIsLockVisitsMode } from "../../store/ganttChart";

export const LockVisitsButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isLockVisitsMode, hasLockVisitsChanged, selectedGanttChartTab } =
    useAppSelector((state) => state.ganttChartSlice);

  const handleClick = () => {
    dispatch(setIsLockVisitsMode(!isLockVisitsMode));
  };

  const showFinalizeButton =
    isLockVisitsMode && selectedGanttChartTab === "Original";

  return (
    <>
      {showFinalizeButton ? (
        <StandardButton
          variant="PRIMARY"
          ariaLabel={labels.finalizeLockVisits}
          onClick={() => {
            dispatch(setIsLockVisitsMode(false));
            if (hasLockVisitsChanged) dispatch(triggerRefetch());
          }}
        >
          {labels.finalizeLockVisits}
        </StandardButton>
      ) : (
        <StandardButton
          variant="SECONDARY"
          ariaLabel={labels.lockVisits}
          onClick={handleClick}
        >
          {labels.lockVisits}
        </StandardButton>
      )}
    </>
  );
};
